export default __webpack_public_path__ + "static/media/neos-logo.90140f05.png";